import WebApi from "./webApi";
import Recorder from "./recorder";
import { API_BASE_URL } from '../config'

export default class {
  recorder = null;
  webApi = null;
  sid = null;
  state = "init";
  reindex = 0;
  params = {};
  TIMER = 100; //发送数据间隔
  // 绘制需要的总点数
  POINT_COUNT = 5000;
  // 初始化波形图点数组
  pointArray = [];
  backData = null;
  canvas = null;
  // 执行动画id
  requesAnimationID = null;
  //失败重试次数
  __retryCount = 5;
  //发送数据定时器
  recordSendTimer = null;
  duration = 0; // 录音时长
  recordingStartTime = 0;
  sendIndex = 0;
  SEND_LIMIT = 10; // 每次发送到后台的最大长度
  sendDataArr = [];
  mp3Url = ''
  xmlUrl = ''
  STATUS_FIRST_FRAME = 0;
  STATUS_CONTINUE_FRAME = 1;
  STATUS_LAST_FRAME = 2;
  //APPID = process.env.VUE_APP_ENVIRONMENT === 'china' ? '5dbbaee5' : 'ga5d3fe0';
  // 因海外购买授权次数暂时受限 所以暂时改为国内
  APPID = process.env.VUE_APP_ENVIRONMENT === 'china' ? '5dbbaee5' : '5dbbaee5';
  AUE = "speex-wb";
  IS_UPLOAD_WAV = true;
  constructor(options = {}) {
    this.error_callback = options.error_callback || this.__onError;
    this.evalute_callback = options.evalute_callback || this.__onEvalute;
    this.record_begin_callbcak = options.record_begin_callbcak || null;
    this.domId = options.domId || "waveform";
  }
  init() {
    return new Promise((resolve, reject) => {
      Recorder.createRecorder({
        numChannels: 1,
        sampleRate: 16000,
        onaudioprocess: (res) => {
          this.__onaudioprocess(res);
        },
        getSpeexData: (res) => {
          this.getSpeexData && this.getSpeexData(res);
        },
      })
        .then((res) => {
          this.recorder = res;
          resolve(true);
        })
        .catch((error) => {
          console.log(error.code);
          console.log(error.message);
          console.log(error.name);
          reject(error);
        });
    });
  }
  getSpeexData(data) {
    let binary = "";
    let bytes = new Uint8Array(data.view.buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    let speexData =  window.btoa(binary);
    this.__recordSend(speexData, data.status);
    this.sendDataArr.concat(data.spxdata);

  }
  cancel() {
    this.state = "cancal";
    console.log("cancel");
    if (this.recordSendTimer) {
      clearTimeout(this.recordSendTimer);
      this.recordSendTimer = null;
    }
    if (this.recorder) {
      this.recorder.stop();
    }
    if (this.webApi) {
      this.webApi.close();
      this.webApi = null;
    }
  }
  destroy() {
    this.state = "destroy";
    if (this.recordSendTimer) {
      clearTimeout(this.recordSendTimer);
      this.recordSendTimer = null;
    }
    if (this.recorder) {
      this.recorder.stop();
      this.recorder.close();
      this.recorder = null;
    }
    if (this.webApi) {
      this.webApi.close();
      this.webApi = null;
    }
  }
  record(params = {}) {
    this.reindex = 0;
    this.state = "start";
    this.sendDataArr = [];
    this.sendIndex = 0;
    this.postEventAiData(); // 上报评测信息
    return new Promise((resolve) => {
      this.params = params;
      if (this.recorder) {
        // return
        this.recorder.clear();
        this.__initWebapi().then((res) => {
          resolve(res);
        });
      } else {
        this.init()
          .then(() => {
            this.__initWebapi().then((res) => {
              resolve(res);
            });
          })
          .catch((error) => {
            this.error_callback(error);
          });
      }
    });
  }
  stop() {
    return new Promise((resolve, reject) => {
      if (this.recorder) {
        const endTime = new Date().getTime();
        this.duration = parseInt((endTime - this.recordingStartTime) / 1000) + ".00";
        this.recorder.stop();
        this.state = "stop";
        this.__clearWaveForm();
        this.webApi.state = this.state;
        resolve();
      } else {
        reject("error");
      }
    });
  }
  /**
   * 重新踩点
   */
  retry(params) {
    if (params) {
      this.params = params;
    }
    console.info("Retry");
    console.log(this.state);
    this.state = "retry";
    this.recorder.clear();
    this.reindex = 0;
    this.sendIndex = 0;
    this.__openWebapi();
  }
  /**
   * 创建本地播放地址
   */
  createSrc() {
    return new Promise((resolve) => {
      this.recorder &
        this.recorder.exportWAV((blob) => {
          let url = URL.createObjectURL(blob);
          resolve(url);
        });
    });
  }
  /**
   * 上传wav到s3
   */
  __uploadWav(sound_xml) {
    return new Promise((resolve, reject) => {
      if (this.IS_UPLOAD_WAV) {
        this.recorder.exportWAVAndUpload(
          // eslint-disable-next-line no-undef
          //UPLOAD_WAV_URL,
          API_BASE_URL + ApiPath.xf_uploadAudioBuffer,
          //'http://39.105.114.220:8080/mock/v1/app/uploadfile-xfyunise',
          {
            sid: this.sid,
            sound_xml: sound_xml,
          },
          data => {
            let result = JSON.parse(data);
            if (result && result.errcode == 0) {
              this.mp3Url = result.data.mp3Path
              this.xmlUrl = result.data.xmlPath
              resolve();
            }
          }
        )
      } else {
        reject(new Error('WAV upload is disabled'));
      }
    });
  }
  __initWebapi() {
    return new Promise((resolve) => {
      let retryCount = this.__retryCount;
      this.webApi = new WebApi({
        evalute_callback: (res) => {
          console.log(res,'评测结束')
          this.sid = res.sid;
          if (res.data.status == 2) {
            this.__uploadWav(res.data.data).then(() => {
              console.log(this.mp3Url,'评测结束')
              res.data.mp3Url = this.mp3Url
              res.data.xmlUrl = this.xmlUrl
              this.evalute_callback(res.data)
            })
          }
          //this.evalute_callback(res.data);
        },
        error_callback: (error) => {
          if (this.recordSendTimer) {
            clearTimeout(this.recordSendTimer);
            this.recordSendTimer = null;
          }
          if (error.code == 0) {
            if (retryCount == 0) {
              this.__sendError(error);
              // this.stop()
              // this.error_callback(error)
            } else {
              // console.clear()
              console.info("Try again");
              retryCount--;
              this.reindex = 0;
              this.sendIndex = 0;
              this.pageTotal = 0;
              this.isAllDecode = false;
              if (this.state !== "destroy") {
                this.__openWebapi();
              }
            }
          } else {
            this.__sendError(error);
          }
        },
      });
      this.webApi.state = this.state;
      this.__openWebapi().then((res) => {
        resolve(res);
      });
    });
  }
  __openWebapi() {
    return new Promise((resolve, reject) => {
      this.webApi
        .open()
        .then((res) => {
          if (this.state == "start") {
            this.recordingStartTime = new Date().getTime();
            this.__clearWaveForm();
            this.__drawWaveform();
            this.record_begin_callbcak && this.record_begin_callbcak();
            this.recorder && this.recorder.record();
            this.state = "ing";
            this.webApi.state = this.state;
          }
          this.webApi.send(this.__startParams());
          if (this.state == "retry") {
            this.__recordSend();
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  __onaudioprocess() {
    const endTime = new Date().getTime();
    this.duration = (endTime - this.recordingStartTime) / 1000;
  }
  __recordSend(data, isComplate) {
    if (this.state == "first" && !isComplate) {
      this.webApi && this.webApi.send(this.__fistParams(data));
      this.state = "ing"
    }
    if (this.state == "ing" && !isComplate) {
      this.webApi && this.webApi.send(this.__middleParams(data));
    }
    if (this.state == "stop" && isComplate) {
      this.webApi && this.webApi.send(this.__middleParams(data));
      this.webApi && this.webApi.send(this.__lastParams(data));
    }
    if (this.state == "retry") {
      const sendData = this.sendDataArr.slice(this.sendIndex, this.sendIndex + this.SEND_LIMIT);
      if (sendData.length) {
        this.webApi && this.webApi.send(this.__middleParams(sendData));
      } else {
        this.webApi && this.webApi.send(this.__lastParams(sendData));
        this.recordSendTimer = setTimeout(() => {
          this.__recordSend();
        }, this.TIMER);
      }
    }
  }
  __startParams() {
    return {
      common: {
        app_id: this.APPID,
      },
      business: {
        category: this.params.category,
        cmd: "ssb",
        ent: "cn_vip",
        text: `\uFEFF` + this.cleanText(this.params.text),
        // aue:  this.AUE,
        aue:  "raw",
        tte: "utf-8",
        rstcd: "utf8",
        ttp_skip: true
      },
      data: {
        status: this.STATUS_FIRST_FRAME
      },
    };
  }
  __fistParams(result) {
    return {
      common: {
        app_id: this.APPID,
      },
      business: {
        "cmd": "auw",
        "aus":1
      },
      data: {
        status: this.STATUS_CONTINUE_FRAME,
        data:  result,
      },
    };
  }
  __middleParams(result, temp_ogg = "", temp_pcm = "") {
    return {
      common: {
        app_id: this.APPID,
      },
      business: {
        "cmd": "auw",
        "aus":2
      },
      data: {
        status: this.STATUS_CONTINUE_FRAME,
        data: result,
      },
    };
  }
  __lastParams(result) {
    return {
      common: {
        app_id: this.APPID,
      },
      business: {
        cmd: "auw",
        "aus": 4
      },
      data: {
        status: this.STATUS_LAST_FRAME,
        data: result,
      },
    };
  }
  __createGuid() {
    var guid = new Date().getTime().toString();
    return guid;
  }
  /**
   * 清除波形图
   */
  __clearWaveForm() {
    if (!this.canvas) {
      return;
    }
    // 停止执行动画
    window.cancelAnimationFrame(this.requesAnimationID);
    this.requesAnimationID = null;

    const W = this.canvas.width;
    let H = this.canvas.height;
    if (this.canvas.getContext) {
      var ctx = this.canvas.getContext("2d");
      ctx.clearRect(0, 0, W, H);
    }
    this.pointArray = [];
    this.backData = null;
  }
  /**
   * 显示波形图
   */
  __drawWaveform() {
    if (!this.canvas) {
      this.canvas = document.getElementById(this.domId);
      if (!this.canvas) return;
    }
    this.requesAnimationID = window.requestAnimationFrame(() => {
      this.__drawWaveform();
    });
    if (this.state != "ing") return;
    this.recorder.analyserNode.getByteTimeDomainData(this.recorder.waveArray);
    let ctx = this.canvas.getContext("2d");
    let dataArray = this.recorder.waveArray;
    var W = this.canvas.width;
    var H = this.canvas.height;
    if (!this.backData) {
      ctx.beginPath();
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = "transparent";
      ctx.fillRect(0, 0, W, H);
      ctx.stroke();
      this.backData = ctx.getImageData(0, 0, W, H);
    } else {
      ctx.putImageData(this.backData, 0, 0);
    }
    ctx.beginPath();
    ctx.strokeStyle = "rgba(250, 174, 86, 1)";
    ctx.lineWidth = 1;
    let sum = 0;
    for (let i = 0; i < dataArray.length; i++) {
      const point = Number(dataArray[i]);
      if (isNaN(point)) {
        continue;
      }
      sum += point;
      let n = 8;
      if ((i + 1) % n == 0) {
        this.pointArray.push(sum / n);
        sum = 0;
      }
    }
    // 绘制的比例
    let widthRate = W / this.POINT_COUNT;
    let beginIndex = 0;
    const pointLength = this.pointArray.length;
    if (pointLength == 0) {
      ctx.stroke();
      return;
    }
    /**
     * 如果当前点的总长度大与需要绘制的总点数，重新获取开始绘制的点
     */
    if (pointLength > this.POINT_COUNT) {
      beginIndex = pointLength - this.POINT_COUNT;
      this.pointArray.splice(0, beginIndex);
    }
    for (let i = 0; i <= pointLength; i++) {
      let v = this.pointArray[i] / 128.0;
      let y = (v * H) / 2;
      let x = i * widthRate;

      if (i === 0) {
        ctx.moveTo(x, y);
      } else {
        ctx.lineTo(x, y);
      }
    }

    ctx.stroke();
    // this.lineData = ctx.getImageData(0, 0, W, H)
  }
  __sendError(error) {
    console.error(error);
    // this.state = 'stop'
    this.recorder && this.recorder.stop();
    // this.recorder.clear()
    this.__clearWaveForm();
    this.error_callback(error);
  }
  __onError(e) {
    console.log(e);
  }
  __onStop() {
    console.log("onstop");
  }
  __onEvalute(e) {
    console.log(e);
  }
  postEventAiData() {
    utilV2.getData(
      ApiPath.xf_evaluation_service,
      {
        engine: "ise",
      },
      () => {
        console.log("register事件记录成功");
      },
      () => {
        console.log("register事件记录失败");
      },
    );
  }
  cleanText(text) {
    // 1. 去掉 [[...]] 和其中的内容
    // 2. 去掉开头的冒号
    return text.replace(/\[\[.*?\]\]/g, '').replace(/^：/, '').trim();
  }
}
